import type { UserSession } from '../slice/userInfoSlice';
import type { DrishtiSignInResult } from './drishtiAuthTypes';

export interface DrishtiSession extends UserSession {
    readonly poolId: string;
}

// Matches /drishti and /drishti/* only, mirroring the CloudFront edge-gate regex
export const isDrishtiPath = (pathname: string): boolean => /^\/drishti(\/|$)/.test(pathname);

// The slice already tells the two apart; this rejects a session the configured pool no longer mints.
export const isDrishtiSession = (
    session: DrishtiSession | undefined,
    drishtiPoolId: string | undefined,
): session is DrishtiSession => Boolean(drishtiPoolId) && session?.poolId === drishtiPoolId;

export const toDrishtiUserSession = (result: DrishtiSignInResult): DrishtiSession => ({
    email: result.email,
    jwt: result.jwt,
    expire: result.expire,
    poolId: result.poolId,
    username: result.username,
    given_name: result.givenName,
    family_name: result.familyName,
    'custom:company': result.company,
});
